import axios from "axios";
import {
  getAccessToken,
  validateUser,
  handleStatusError
} from "../util/Auth.js";
import querystring from "query-string";

const APIRoute = process.env.REACT_APP_API_HOST;

export const fetchUser = () => async dispatch => {
  dispatch({ type: "USER_START" });
  try {
    const access = await validateUser();
    const { result } = access;
    const { Value: userName } = result[0];

    let assignedBranch = result.filter(r => r.Key === "FleetBranchId");
    let regionCode = result.filter(r => r.Key === "RegionCode");

    assignedBranch =
      assignedBranch.length > 0 ? assignedBranch[0].Value : undefined;

    regionCode = regionCode.length > 0 ? regionCode[0].Value : undefined;

    dispatch({
      type: "USER_SUCCESS",
      payload: {
        user: userName,
        assignedBranch,
        regionCode,
        validated: true
      }
    });
  } catch (error) {
    dispatch({ type: "USER_ERROR", payload: error.message });
    handleStatusError(error.response && error.response.status);
  }
};

export const setEquipmentFetchID = fetchID => dispatch => {
  dispatch({ type: "SETFETCHID", payload: { fetchID } });
};

export const fetchEquipmentForm = (params, newFetchID) => async dispatch => {
  dispatch({ type: "EQUIPMENT_START" });
  try {
    const equipmentList = await axios.get(
      `${APIRoute}baseplan/api/product/serial-product?${params}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    dispatch({
      type: "EQUIPMENT_SUCCESS",
      payload: { ...equipmentList.data.result, newFetchID }
    });
  } catch (e) {
    if (e && e.response) handleStatusError(e.response.status);
  }
};

export const setEquipmentDetails = equipmentDetails => async dispatch => {
  dispatch({
    type: "SETDETAILS",
    payload: equipmentDetails
  });
};

export const fetchEquipmentDetails = (fleetNo, branchID) => async dispatch => {
  dispatch({ type: "EQUIPMENTDETAILS_START" });
  try {
    const params =
      "take=10" +
      "&Where.OperatorType=And" +
      "&Where.Operands[0].Field=fleetNo" +
      "&Where.Operands[0].FilterType=Equal" +
      `&Where.Operands[0].Value=${fleetNo}` +
      "&Where.Operands[1].Field=fleetBranchId" +
      "&Where.Operands[1].FilterType=Equal" +
      `&Where.Operands[1].Value=${branchID}`;

    const equipmentDetails = await axios.get(
      `${APIRoute}baseplan/api/product/serial-product?${params}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    dispatch({
      type: "EQUIPMENTDETAILS_SUCCESS",
      payload: equipmentDetails.data.result.items[0]
    });
    return equipmentDetails.data.result.items;
  } catch (error) {
    dispatch({ type: "EQUIPMENTDETAILS_ERROR", payload: error.message });
    handleStatusError(error.response.status);
  }
};

export const fetchBranchDetails = (branchID, branchCode) => async dispatch => {
  dispatch({ type: "BRANCHDETAIL_START" });
  try {
    let params = {
      Take: 10,
      "Where.OperatorType": "And",
      "Where.Operands[0].Field": "id",
      "Where.Operands[0].FilterType": "Equal",
      "Where.Operands[0].Value": branchID,
      "Where.Operands[1].Field": "code",
      "Where.Operands[1].FilterType": "contains",
      "Where.Operands[1].Value": branchCode
    };
    const branchList = await axios.get(
      `${APIRoute}baseplan/api/branch/divisions?${querystring.stringify(
        params
      )}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    dispatch({
      type: "BRANCHDETAIL_SUCCESS",
      payload: branchList.data.result[0]
    });
    const masterParams = {
      ...params,
      "Where.Operands[2].Field": "isMain",
      "Where.Operands[2].FilterType": "Equal",
      "Where.Operands[2].Value": "True"
    };

    const branchMaster = await axios.get(
      `${APIRoute}baseplan/api/branch/divisions?${querystring.stringify(
        masterParams
      )}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    dispatch({
      type: "BRANCHMASTER_SUCCESS",
      payload: branchMaster.data.result[0]
    });
  } catch (error) {
    dispatch({ type: "BRANCHDETAIL_ERROR", payload: error.message });
    handleStatusError(error.response.status);
  }
};

export const fetchBranchEmployees = branchID => async dispatch => {
  dispatch({ type: "EMPLOYEES_START" });
  try {
    const queryParams =
      `Where.OperatorType=And` +
      `&Where.Operands[0].Field=fleetBranchId` +
      `&Where.Operands[0].FilterType=Equal` +
      `&Where.Operands[0].Value=${branchID}` +
      `&OrderBy[0].Field=Description` +
      `&OrderBy[0].Order=Asc`;
    const employeesList = await axios.get(
      `${APIRoute}baseplan/api/user?${queryParams}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    const { result } = employeesList.data;
    dispatch({ type: "EMPLOYEES_SUCCESS", payload: result });
  } catch (error) {
    dispatch({ type: "EMPLOYEES_ERROR", payload: error.response.data });
    handleStatusError(error.response.status);
  }
};

export const fetchConditions = () => async dispatch => {
  try {
    const queryParams = "OrderBy[0].Field=Status&OrderBy[0].Order=Asc";
    const conditions = await axios.get(
      `${APIRoute}baseplan/api/product/conditions?${queryParams}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    dispatch({ type: "CONDITIONS", payload: conditions.data.result });
  } catch (error) {
    handleStatusError(error.response && error.response.status);
  }
};

export const fetchCategories = () => async dispatch => {
  dispatch({ type: "CATEGORY_START" });
  try {
    const categoryList = await axios.get(
      `${APIRoute}baseplan/api/product/categories`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    const { result } = categoryList.data;
    dispatch({
      type: "CATEGORY_SUCCESS",
      payload: result.sort(sortFunction)
    });
  } catch (error) {
    dispatch({ type: "CATEGORY_ERROR", payload: error.message });
    handleStatusError(error.response && error.response.status);
  }
};

export const fetchSubCategories = catType => async dispatch => {
  dispatch({ type: "SUBCATEGORY_START" });
  try {
    const categoryList = await axios.get(
      `${APIRoute}baseplan/api/product/sub-categories?OrderBy[0].Field=type&OrderBy[0].Order=Asc`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    const { result } = categoryList.data;
    dispatch({
      type: "SUBCATEGORY_SUCCESS",
      payload: result
    });
  } catch (error) {
    dispatch({ type: "CATEGORY_ERROR", payload: error.message });
    handleStatusError(error.response && error.response.status);
  }
};

function sortFunction(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

export const fetchBranchRegions = () => async dispatch => {
  try {
    const branchList = await axios.get(
      `${APIRoute}baseplan/api/branch?Skip=0&Take=300&OrderBy[0].Field=description&OrderBy[0].Order=Asc`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );
    const branches = branchList.data.result;
    // there is no api that fetches all the equipment categories so we need
    // to fetch all the branches and then get all the regionCode's
    dispatch({ type: "BRANCH_SUCCESS", payload: branches.items });
    dispatch({
      type: "BRANCHREGION",
      payload: [...new Set(branches.items.map(item => item.regionCode))].sort(
        sortFunction
      )
    });
  } catch (error) {
    handleStatusError(error.response && error.response.status);
  }
};
